function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import { Injectable, NgModule } from '@angular/core';
import { Observable, of, merge, fromEvent } from 'rxjs';
import { mergeMap, map } from 'rxjs/operators';
var FileDetailsModel = /*#__PURE__*/_createClass(
// 408949 // 500kb
// 1197292 // 1mb
// 4952221 // 5mb
// 13848150 // 15mb
function FileDetailsModel() {
  _classCallCheck(this, FileDetailsModel);
  this.path = 'https://raw.githubusercontent.com/jrquick17/ng-speed-test/02c59e4afde67c35a5ba74014b91d44b33c0b3fe/demo/src/assets/5mb.jpg';
  this.shouldBustCache = true;
  this.size = 4952221;
});
var SpeedDetailsModel = /*#__PURE__*/function () {
  function SpeedDetailsModel(fileSize) {
    _classCallCheck(this, SpeedDetailsModel);
    this.fileSize = fileSize;
    this.duration = 0;
    this.hasEnded = false;
    this.startTime = null;
    this.endTime = null;
    this.speedBps = 0;
  }
  _createClass(SpeedDetailsModel, [{
    key: "_update",
    value: function _update() {
      if (this.endTime !== null) {
        var milliseconds = this.endTime - this.startTime;
        if (milliseconds !== 0) {
          this.duration = milliseconds / 1000;
        }
        var bitsLoaded = this.fileSize * 8;
        this.speedBps = bitsLoaded / this.duration;
      }
    }
  }, {
    key: "end",
    value: function end() {
      if (!this.hasEnded) {
        this.hasEnded = true;
        this.endTime = new Date().getTime();
        this._update();
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (!this.hasEnded) {
        this.hasEnded = true;
        this.endTime = null;
        this._update();
      }
    }
  }, {
    key: "start",
    value: function start() {
      this.startTime = new Date().getTime();
    }
  }]);
  return SpeedDetailsModel;
}();
var SpeedTestService = /*#__PURE__*/function () {
  function SpeedTestService() {
    _classCallCheck(this, SpeedTestService);
    this._applyCacheBuster = function (path) {
      return path + '?nnn=' + Math.random();
    };
  }
  _createClass(SpeedTestService, [{
    key: "_download",
    value: function _download(iterations, fileDetails, allDetails) {
      var _this = this;
      return new Observable(function (observer) {
        var newSpeedDetails = new SpeedDetailsModel(fileDetails.size);
        var download = new Image();
        download.onload = function () {
          newSpeedDetails.end();
          observer.next(newSpeedDetails);
          observer.complete();
        };
        download.onerror = function () {
          newSpeedDetails.error();
          observer.next(newSpeedDetails);
          observer.complete();
        };
        var filePath = fileDetails.path;
        if (fileDetails.shouldBustCache) {
          filePath = _this._applyCacheBuster(filePath);
        }
        newSpeedDetails.start();
        download.src = filePath;
      }).pipe(mergeMap(function (newSpeedDetails) {
        if (typeof allDetails === 'undefined') {
          allDetails = [];
        }
        allDetails.push(newSpeedDetails);
        if (typeof iterations === 'undefined') {
          iterations = 3;
        }
        if (iterations === 1) {
          var count = allDetails.length;
          var total = 0;
          for (var i = 0; i < count; i++) {
            total += allDetails[i].speedBps;
          }
          var speedBps = total / count;
          return of(speedBps);
        } else {
          return _this._download(--iterations, fileDetails, allDetails);
        }
      }));
    }
  }, {
    key: "getBps",
    value: function getBps(iterations, fileDetails) {
      var _this2 = this;
      return new Observable(function (observer) {
        window.setTimeout(function () {
          if (typeof fileDetails === 'undefined') {
            fileDetails = new FileDetailsModel();
          } else {
            if (typeof fileDetails.path === 'undefined') {
              console.error('ng-speed-test: File path is missing.');
              return null;
            }
            if (typeof fileDetails.size === 'undefined') {
              console.error('ng-speed-test: File size is missing.');
              return null;
            }
            if (typeof fileDetails.shouldBustCache === 'undefined') {
              fileDetails.shouldBustCache = true;
            } else {
              fileDetails.shouldBustCache = fileDetails.shouldBustCache === true;
            }
          }
          _this2._download(iterations, fileDetails).subscribe(function (speedBps) {
            observer.next(speedBps);
            observer.complete();
          });
        }, 1);
      });
    }
  }, {
    key: "getKbps",
    value: function getKbps(iterations, fileDetails) {
      return this.getBps(iterations, fileDetails).pipe(map(function (bps) {
        return bps / 1024;
      }));
    }
  }, {
    key: "getMbps",
    value: function getMbps(iterations, fileDetails) {
      return this.getKbps(iterations, fileDetails).pipe(map(function (kpbs) {
        return kpbs / 1024;
      }));
    }
  }, {
    key: "isOnline",
    value: function isOnline() {
      return merge(fromEvent(window, 'offline').pipe(map(function () {
        return false;
      })), fromEvent(window, 'online').pipe(map(function () {
        return true;
      })), new Observable(function (sub) {
        sub.next(navigator.onLine);
        sub.complete();
      }));
    }
  }]);
  return SpeedTestService;
}();
SpeedTestService.decorators = [{
  type: Injectable
}];
SpeedTestService.ctorParameters = function () {
  return [];
};
var SpeedTestModule = /*#__PURE__*/_createClass(function SpeedTestModule() {
  _classCallCheck(this, SpeedTestModule);
});
SpeedTestModule.decorators = [{
  type: NgModule,
  args: [{
    providers: [SpeedTestService]
  }]
}];

/**
 * Generated bundle index. Do not edit.
 */

export { FileDetailsModel, SpeedTestModule, SpeedTestService };